$(function () {
    const RecordingAutoServiceFormClass = function () {
        var $form = $('.recording-auto-service-form');

        this.init = function () {
            $form.find('button[type="submit"]').on('click', function () {
                $.post($form.attr('action'), $form.serialize(), function (response) {
                    if (response.status === 'error') {
                        return false;
                    }

                    $form.trigger('reset');
                    $form.parent().append($('<div/>', {
                        class: 'remodal b-form_border remont',
                        'data-remodal-id': 'success',
                        html: [
                            $('<button/>', {
                                'data-remodal-action':'close',
                                class: 'remodal-close remont',
                                html: $('<i/>', { class: 'ic-close' })
                            }),
                            $('<div/>', {
                                class: 'b-title_remont',
                                html: $('<div/>', {
                                    class: 'b-title_name_remont',
                                    text: 'Спасибо за обращение в наш автосервис!'
                                })
                            }),
                            $('<div/>', {
                                class: 'b-form_field',
                                html: 'Через некоторое время с вами свяжется <br> наш менеджер'
                            })
                        ]
                    }));

                    $("body").addClass("success-alert");
                });

                return false;
            });
        };
    };

    new RecordingAutoServiceFormClass().init();
});